import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

/** Scroll container whose 8px scrollbar keeps a visible track, unlike ThinScrollArea's transparent one. */
export const VisibleScrollbarArea = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  paddingRight: theme.spacing(1),
  '&::-webkit-scrollbar': { width: '8px' },
  '&::-webkit-scrollbar-track': {
    backgroundColor: alpha(theme.palette.common.black, 0.1),
    borderRadius: theme.shape.borderRadius,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(theme.palette.common.black, 0.3),
    borderRadius: theme.shape.borderRadius,
    '&:hover': { backgroundColor: alpha(theme.palette.common.black, 0.5) },
  },
}));
